<template>
  <div class="tab grid flex-wrap flex-justify-center">
    <div
      v-for="product in showProducts"
      :key="product.productId"
      class="item flex flex-column flex-align-center point-cursor"
      @click="$emit('click-product', product)"
    >
      <ProductFlagItem
        :icon-url="product.landmarkImageUrl"
        :flag="product.imageUrl"
        :name="product.name"
        :description="product.benefitText"
        :badge="product.hasLimitedOption ? '무제한' : ''"
      />
    </div>
    <ProductFlagItem
      v-if="showMoreButton"
      is-more
      @click-item="$emit('click-more')"
    />
  </div>
  <div
    v-if="showMore"
    class="tw:flex tw:items-center tw:justify-center tw:gap-1 tw:py-2.5 tw:cursor-pointer"
    @click="isExpanded = !isExpanded"
  >
    <span class="tw:typo-text-m tw:text-usdg-color-gray-700">{{
      isExpanded ? `${categoryName} 접기` : `${categoryName} ${remainProductCount}`
    }}</span>
    <Icons
      path="outline/chevron-down"
      size="16"
      :class="{ 'tw:rotate-180': isExpanded }"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    products: IProduct[]
    showMore?: boolean
    max?: number
    categoryName?: string
  }>(),
  {
    showMore: false,
    max: 11,
    categoryName: '인기국가'
  }
)

const emit = defineEmits(['click-product', 'click-more'])

const isExpanded = ref(false)

const showProducts = computed(() =>
  props.showMore && !isExpanded.value ? props.products.slice(0, props.max) : props.products
)
const showMoreButton = computed(() => props.showMore)
const remainProductCount = computed(() => {
  return props.products.length > props.max
    ? `더보기 (${Number(props.products.length - props.max)})`
    : ''
})
</script>

<style lang="scss" scoped>
.tab {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: $space-26;
  justify-items: center;
  .item {
    padding-bottom: $space-8;
    width: 100%;
    .product_name {
      @include body7-regular;
      width: $space-72;
      color: $gray-500;
      word-break: keep-all;
      white-space: pre-wrap;
      text-align: center;
    }
  }
}
</style>
